/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    class="col-lg-10"
  >
    <h2>{{ header }}</h2>
    <div class="prompt">
      {{ subtext }}
    </div>
    <div class="button-container1">
      <div class="button-container2">
        <button
          type="button"
          class="btn btn-primary"
          style="float: left"
          @click.prevent="button1.action()"
        >
          {{ button1.text }}
        </button>

        <button
          type="button"
          class="btn btn-primary"
          style="float: right"
          @click.prevent="button2.action()"
        >
          {{ button2.text }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  h2, .prompt {
    text-align: center;
  }
  .prompt {
    margin-bottom: 20px;
  }
  .button-container1 {
    text-align: center;
  }
  .button-container2 {
    display: inline-block;
    width: 300px;
  }
</style>

<script>
export default {
  props: ['header', 'subtext', 'button1', 'button2'],
  data() {
    return {
    };
  },
};
</script>
